import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = React.useMemo(() => ({ from: location }), [location]);
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-gold/80 label-mono">Chargement...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={redirectState} replace />;
  return children;
};
